<div  top="0" left="0" zIndex="1000" a-style bg="rgb(0,0,0,0.8)" display="flex" justify="center"  alignItems="center" position="fixed"  h="100vh" w="100vw">
    <ng-container [ngTemplateOutlet]="modalWithFormat" ></ng-container>
  </div>
  <ng-template #modalWithFormat>

    <div class="modal">

    </div>
  </ng-template>